import MarkdownRenderer from './renderers/MarkdownRenderer';
import IframeRenderer from './renderers/IframeRenderer';
import ContentPanelInputRenderer from './renderers/ContentPanelInputRenderer';
import InputFormRenderer from './InputFormRenderer/InputFormRenderer';
import HtmlRenderer from './renderers/HtmlRenderer';

/**
 * RendererRegistry — strategy pattern, resolves renderer by entry.format.
 * Add new formats here — ContentPanel never needs to change.
 *
 * Format convention:
 * - null / undefined — MarkdownRenderer (default)
 * - html             — HtmlRenderer (tiptap WYSIWYG body)
 * - *_data           — IframeRenderer (data note linked to a template via tid)
 */
const _registry = {
    recipe_data:       IframeRenderer,
    intake_data:       ContentPanelInputRenderer,
    // v2 formats
    intake_v2_data:    InputFormRenderer,
    recipe_v2_data:    InputFormRenderer,
};

/**
 * Resolves the correct renderer component for a given format.
 * Returns MarkdownRenderer as default when format is unknown or null.
 * @param {string|null} format - entry.format value
 * @returns {React.Component} renderer component
 */
const resolve = (format) => {
    if (!format) return MarkdownRenderer;
    return _registry[format] ?? MarkdownRenderer;
};

const RendererRegistry = { resolve };
export default RendererRegistry;
